import React from "react";
import { motion } from "framer-motion";

/**
 * Layered atmospheric backdrop for inner-page heroes — drifting aurora blobs,
 * masked dot texture and a soft grain overlay, matching the Home page depth.
 * Palette-locked to teal / green / gold.
 */
export const PageAtmosphere = () => (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden>
        <div className="aurora-blob blob-emerald drift-a" style={{ top: "-14%", left: "6%", width: 460, height: 460 }} />
        <div className="aurora-blob blob-amber drift-c" style={{ top: "26%", right: "2%", width: 400, height: 400 }} />
        <div className="aurora-blob blob-violet drift-b" style={{ bottom: "-20%", left: "38%", width: 380, height: 380 }} />
        <div
            className="absolute inset-0 dot-bg"
            style={{
                opacity: 0.35,
                maskImage: "radial-gradient(ellipse 72% 62% at 50% 28%, #000 0%, transparent 72%)",
                WebkitMaskImage: "radial-gradient(ellipse 72% 62% at 50% 28%, #000 0%, transparent 72%)",
            }}
        />
        <div className="grain-overlay" />
    </div>
);

/**
 * Small floating glass chip used as a hero accent.
 */
export const FloatChip = ({ icon, label, accent = "#5FA88A", className = "", delay = 0 }) => (
    <motion.div
        initial={{ opacity: 0, scale: 0.85, y: 12 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
        className={`hidden lg:flex float-chip glass-card items-center gap-2.5 px-4 py-2.5 ${className}`}
        style={{ borderRadius: 999, animationDelay: `${delay}s` }}
    >
        <span className="w-7 h-7 rounded-full grid place-items-center shrink-0" style={{ background: `${accent}1f` }}>
            <i className={`${icon} text-xs`} style={{ color: accent }} />
        </span>
        <span className="text-xs font-medium text-slate-700 whitespace-nowrap">{label}</span>
    </motion.div>
);

/**
 * Glass eyebrow pill with a status dot.
 */
export const EyebrowPill = ({ label, accent = "#5FA88A", testid }) => (
    <span
        className="inline-flex items-center gap-2 glass-card px-4 py-1.5 text-[11px] uppercase tracking-[0.18em] text-slate-600 font-medium"
        style={{ borderRadius: 999 }}
        data-testid={testid}
    >
        <span className="w-1.5 h-1.5 rounded-full" style={{ background: accent, boxShadow: `0 0 8px ${accent}` }} />
        {label}
    </span>
);

export default PageAtmosphere;
